import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { mapToVoid } from '@examdojo/core/rxjs';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { of, take } from 'rxjs';
import { ClassQuery } from '../class/class.query';
import { ClassInsightsService } from './class-insights.service';

export const classInsightsResolver: ResolveFn<void> = () => {
  const classInsightsService = inject(ClassInsightsService);
  const classQuery = inject(ClassQuery);
  const errorHandler = inject(ErrorHandlerService);

  const classId = classQuery.getActiveId() || undefined;
  if (!classId) {
    return;
  }

  return classInsightsService.init(classId).pipe(
    errorHandler.catchHttpErrors(() => of(undefined)),
    take(1),
    mapToVoid(),
  );
};
